/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { env, checkEnv, installEnvDep } from './env';
import Router from '../router';

const {
  joinPath,
} = require('../utils/util');

switch (checkEnv()) {
  case env.WX_MP:
  case env.WX:
    if (typeof wx === 'undefined') {
      installEnvDep('https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
    }
    break;
}

class Share {
  static config(share = {}) {
    if (!share.route) {
      share.route = window.location.href;
    }
    Share.share = share;
    switch (checkEnv()) {
      case env.WX_MP:
        this._setWXMPShareInfo(share);
        break;
      case env.WX:
        this._setWXShareInfo(share);
        break;
      case env.QQ:
        this._setQQShareInfo(share);
        break;
    }
  }

  static setShareRoute(route) {
    this.config({
      ...Share.share,
      route,
    });
  }

  // 微信小程序
  static _setWXMPShareInfo(share) {
    try {
      wx.miniProgram.postMessage({
        data: {
          shareInfo: {
            title: share.title,
            img: share.img,
            route: share.route,
          },
        },
      });
    } catch (err) {}
  }

  static _setQQShareInfo(share) {
    if (window.mqq && window.mqq.invoke && typeof window.mqq.invoke === 'function') {
      window.mqq.invoke('data', 'setShareInfo', {
        share_url: share.route,
        title: share.title,
        desc: share.title,
        image_url: share.img,
      });
    }
  }

  // 微信
  static _setWXShareInfo(share) {
    const share_url = Router.convert(share.route);
    const wechat_url = joinPath(share_url, [{ key: 'adtag', value: 'wechatshare' }]);
    const desc = share.desc || share.title || 'desc';
    const { title } = share;
    const { img } = share;

    const onBridgeReady = function () {
      // 转发朋友圈
      WeixinJSBridge.on('menu:share:timeline', (e) => {
        const data = {
          img_url: img,
          img_width: '120',
          img_height: '120',
          link: wechat_url,
          // desc这个属性要加上，虽然不会显示，但是不加暂时会导致无法转发至朋友圈，
          desc,
          title,
        };
        WeixinJSBridge.invoke('shareTimeline', data, (res) => {
          WeixinJSBridge.log(res.err_msg);
        });
      });
      // 分享给朋友
      WeixinJSBridge.on('menu:share:appmessage', (argv) => {
        WeixinJSBridge.invoke(
          'sendAppMessage', {
            img_url: img,
            img_width: '120',
            img_height: '120',
            link: share_url,
            desc,
            title,
          },
          (res) => {
            WeixinJSBridge.log(res.err_msg);
          },
        );
      });
    };
    if (
      typeof top.window.WeixinJSBridge === 'undefined'
            || !top.window.WeixinJSBridge.invoke
    ) {
      // 没有就监听ready事件
      if (document.addEventListener) {
        document.addEventListener(
          'WeixinJSBridgeReady',
          onBridgeReady,
          false,
        );
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
      }
    } else {
      // 初始化结束直接就执行吧！
      onBridgeReady();
    }
  }
}

Share.share = null;

export default Share;
